import { useCallback } from "react";
import { useMutation } from "@apollo/react-hooks";

import { useAppState } from "core/contexts/AppContext";
import { SAVE_USER } from "core/includes/queries";

const useUser = () => {
    const [appState, setAppState] = useAppState();

    const [saveUser] = useMutation(SAVE_USER);

    const getAndSaveUser = useCallback(() => {
        appState.getUser().then((res: any) => {
            setAppState({
                authorised: true,
            });

            const userId = res?.id || 0;
            if (userId) {
                saveUser({
                    variables: {
                        userId,
                    }
                })
            }
        });
    }, [appState, saveUser, setAppState]);

    return { getAndSaveUser };
}

export default useUser;